import { useQuery } from '@apollo/react-hooks';

import { isErrorMarkedAsHandled, markErrorAsHandled } from '@confluence/graphql-error-processor';

import { StorageUsageDataQuery } from '../../graphql/StorageUsageDataQuery.graphql';

function bytesToGigabytes(bytes: number) {
	return bytes / 1000 / 1000 / 1000;
}

function toDecimalPlaces(num: number, decimalPlaces: number) {
	const multiplier = Math.pow(10, decimalPlaces);
	return Math.floor(num * multiplier) / multiplier;
}

export const useGetStorageUsageData = () => {
	const { data, error, loading } = useQuery(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
		StorageUsageDataQuery,
		{
			fetchPolicy: 'cache-and-network',
		},
	);

	if (error && !isErrorMarkedAsHandled(error)) {
		markErrorAsHandled(error);
	}

	const bytesUsed = data?.storage?.bytesUsed;

	const gigabytesUsed = bytesToGigabytes(bytesUsed);

	return {
		error,
		loading,
		dataUsed: !loading && !error ? toDecimalPlaces(gigabytesUsed, 1) : 0,
	};
};
